import { useEffect } from 'react';

/**
 * Pre-fill a form field when the option set has exactly one entry and the
 * field is currently empty. Used at three sites in the multi-claim submit
 * flow: claim-type / location / directory-provider.
 *
 * The hook deliberately stays small. The "what counts as empty" decision
 * lives at the call site (passed as `isEmpty`) so it can match the field's
 * own data shape (string vs array vs object).
 */
export function useAutoSelectSingleOption<T>(
  options: readonly T[],
  isEmpty: boolean,
  setValue: (value: T) => void,
): void {
  useEffect(() => {
    if (options.length === 1 && isEmpty) {
      setValue(options[0]);
    }
  }, [options, isEmpty, setValue]);
}
